import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_STATUS').plugin(axiosPlugin);


let fetchUserStatusAction = redux.fetchActionGetOne();

let createUserStatusAction = redux.fetchActionCreate();

let updateUserStatusAction = redux.fetchActionUpdate();

let deleteUserStatusAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchUserStatus = (userId, statusId, query = {}) => fetchUserStatusAction(`/users/${userId}/status/${statusId}?${queryString.stringify(query)}`);
export const createUserStatus = (userId, data) => createUserStatusAction(`/users/${userId}/status/`, data);
export const updateUserStatus = (userId, statusId, data = {}) => updateUserStatusAction(`/users/${userId}/status/${statusId}`, data);
export const deleteUserStatus = (userId, statusId = {}) => deleteUserStatusAction(`/users/${userId}/status/${statusId}`);
export const resetUserStatus = () => redux.actions.reset();

export const userStatus = redux.reducer();